<div (click)="switchKennzahl()" class="wrap" fxLayout="column">

  <div class="titel bold" fxFlex="auto" fxLayoutAlign="center">{{kennzahlen[0].headerText}}</div>

  <div class="date" fxFlex="auto" fxLayoutAlign="center">
    <ng-container *ngIf="dayMonthYearIndex === 0">
      am {{startDate | dateToStringPipe}}
    </ng-container>
    <ng-container *ngIf="dayMonthYearIndex === 1">
      aktueller Monat
    </ng-container>
    <ng-container *ngIf="dayMonthYearIndex === 2">
      aktuelles Jahr
    </ng-container>
  </div>

  <br>

  <div class="bold value" fxFlex="auto" fxFlexAlign="center">
    {{kennzahlen[0].dayMonthYearValues[dayMonthYearIndex] | adaptedDecimal}} {{kennzahlen[0].unit}}
  </div>

  <br>

  <div fxFlex="auto" style="text-align: center">
    entspricht
    <span
      class="bold value">{{kennzahlen[1].dayMonthYearValues[dayMonthYearIndex] | adaptedDecimal}} {{kennzahlen[1].unit}}</span>
    CO<sub>2</sub> eingespart
  </div>

</div>
